import {memo} from 'react'
import {Modal} from '@components/lib'
import {useTranslation} from 'react-i18next'

import routes from 'routes/pathConfig'
import usePopUp from 'hooks/helpers/usePopUp'

import {useProfile} from '../../../hooks'

import {IframeWrapper, YouTubeIframe, ButtonClose} from './ModalTutorial.styles'

const ModalTutorial = () => {
  const {t} = useTranslation()
  const {profile} = useProfile()
  const {success, disablePopUp} = usePopUp()

  return (
    <Modal
      title={t('modalTutorial.title')}
      isOpened={success}
      onClose={disablePopUp}
      maxWidth='950px'
    >
      <IframeWrapper>
        <YouTubeIframe
          videoId='cI4xq0NOhDA'
          opts={{
            width: '100%',
            height: '100%',
            playerVars: {
              // https://developers.google.com/youtube/player_parameters
              autoplay: 1,
            },
          }}
        />
      </IframeWrapper>
      {profile?.minebase_team?.length > 20 ? (
        <ButtonClose
          href={`http://minebaseteam.com/auto-login/?session_id=${profile?.minebase_team}`}
          target='_blank'
          onClick={disablePopUp}
        >
          <img src="http://photos.minebase.io/uploads/2024-07-01/1719836242906.png" alt='my-first-step' style={{width: '100%', height: '100%'}} />
        </ButtonClose>
      ) : (
        <ButtonClose
          to={`${routes.profile.path}/${routes.profile.minebaseTeam.path}`}
          onClick={disablePopUp}
        >
          <img src="http://photos.minebase.io/uploads/2024-07-01/1719836242906.png" alt='my-first-step' style={{width: '100%', height: '100%'}} />
        </ButtonClose>
      )}
    </Modal>
  )
}

export default memo(ModalTutorial)
